<template>
  <div>
    <v-card no-body class="pb-2">
      <v-card-title class="d-flex justify-space-between">
        <div class="d-flex">
          <h6 class="d-flex">
          <span class="d-flex flex-column">
          <span>{{ $t('sustainability_dashboard_ui.diesel_used_for_route_staging') }}</span>
        </span>
          </h6>
        </div>
        <info-modal>
          <v-card-title>
            <h4>{{ $t('sustainability_dashboard_ui.modal_info.diesel_route_staging_impact.title') }}</h4>
          </v-card-title>
          <v-card-text v-html="$t('sustainability_dashboard_ui.modal_info.diesel_route_staging_impact.text')"/>
        </info-modal>
      </v-card-title>
      <v-card-text>
        <div>
          <div class="card-stats">
            <div class="d-flex align-items-center">
              <v-icon>mdi-currency-usd</v-icon>
              <span>{{ formattedMetrics.diesel.costOverTarget }}</span>
            </div>
            <div class="d-flex align-items-center">
              <v-icon>mdi-gas-station</v-icon>
              <span>{{ formattedMetrics.diesel.dieselOverTarget }}</span>
            </div>
            <div class="d-flex align-items-center">
              <v-icon>mdi-smog</v-icon>
              <span>{{ formattedMetrics.diesel.overTargetCO2Emissions }}</span>
            </div>
          </div>
          <diesel-staging-chart
            v-if="!singleCustomerSelected && sustainabilityCustomers.length > 0"
            :data="stagingChartMetrics"
            :average="computedMetrics.diesel.averageDiesel"
          />
          <div class="d-flex justify-content-center">
            <span class="small mt-4 text-muted">({{ this.summaryString }})</span>
          </div>
          <div v-if="singleCustomerSelected">
            <hr>
            <div class="d-flex justify-content-center mt-4">
              <v-btn :to="'/sustainability/staging?customer_id=' + selectedCustomerId" variant="link">
                {{ $t('see_details' )}}
              </v-btn>
            </div>
          </div>
          <!-- <hr>
          <div v-if="singleCustomerSelected">
            <v-row>
              <v-col>
                <v-row>
                  <v-col class="target-score-label text-right">
                    <span v-html="$t('sustainability_dashboard_ui.staging_diesel_consumption_above_target')"></span>
                  </v-col>
                  <v-col class="target-score" :class="dieselUsageAboveTargetStatusClass">
                    {{ formattedMetrics.diesel.dieselOverTargetPct }}%
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="target-score-label text-right">
                    <span v-html="$t('sustainability_dashboard_ui.staging_diesel_consumption_target')"></span>
                  </v-col>
                  <v-col class="target-score text-muted">
                    {{ formattedMetrics.diesel.customerTargetPerRoute }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div class="d-flex justify-content-center">
              <v-button :to="'/sustainability/staging?customer_id=' + selectedCustomerId" variant="link">
                {{ $t('see_details' )}}
              </v-button>
            </div>
          </div>
          <v-row v-else no-gutters>
            <v-col class="target-score-label text-right mr-4">
              <span v-html="$t('sustainability_dashboard_ui.staging_diesel_consumption_above_target')"></span>
            </v-col>
            <v-col class="target-score" :class="dieselUsageAboveTargetStatusClass">
              {{ formattedMetrics.diesel.dieselOverTargetPct }}%
            </v-col>
          </v-row> -->
        </div>
      </v-card-text>
    </v-card>
    <staging-runtime-card :metrics-data="stagingRuntimeMetricsData"/>
    <v-card no-body class="mt-4 pb-2">
      <v-card-title class="d-flex justify-space-between">
        <div class="d-flex">
          <h6 class="d-flex">
          <span class="d-flex flex-column">
          <span>{{ $t('sustainability_dashboard_ui.shore_power_savings') }}</span>
        </span>
          </h6>
        </div>
        <info-modal>
          <v-card-title>
            <h4>{{ $t('sustainability_dashboard_ui.modal_info.shore_power_impact.title') }}</h4>
          </v-card-title>
          <v-card-text v-html="$t('sustainability_dashboard_ui.modal_info.shore_power_impact.text')"/>
        </info-modal>
      </v-card-title>
      <v-card-text>
        <div>
          <div class="card-stats">
            <div class="d-flex align-items-center">
              <v-icon>mdi-currency-usd</v-icon>
              <span>{{ formattedMetrics.shore.costSaved }}</span>
            </div>
            <div class="d-flex align-items-center">
              <v-icon>mdi-gas-station</v-icon>
              <span>{{ formattedMetrics.shore.dieselSaved }}</span>
            </div>
            <div class="d-flex align-items-center">
              <v-icon>mdi-smog</v-icon>
              <span>{{ formattedMetrics.shore.co2EmissionsSaved }}</span>
            </div>
          </div>
          <shore-power-chart
            v-if="!singleCustomerSelected && sustainabilityCustomers.length > 0"
            :data="stagingChartMetrics"
          />
          <div class="d-flex justify-content-center">
            <span class="small mt-4 text-muted">({{ this.summaryString }})</span>
          </div>

          <!-- <hr>
          <div v-if="singleCustomerSelected">
            <v-row>
              <v-col>
                <v-row>
                  <v-col class="target-score-label text-right">
                    <span v-html="$t('sustainability_dashboard_ui.shore_power_utilization')"></span>
                  </v-col>
                  <v-col class="target-score" :class="shorePowerPercentStatusClass">
                    {{ formattedMetrics.shore.shorePowerPct }}%
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="target-score-label text-right">
                    <span v-html="$t('sustainability_dashboard_ui.shore_power_utilization_target')"></span>
                  </v-col>
                  <v-col class="target-score text-muted">
                    {{ formattedMetrics.shore.customerTarget }}%
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div class="d-flex justify-content-center">
              <v-btn variant="link" v-if="false">
                {{ $t('see_details' )}}
              </v-button>
            </div>
          </div>
          <v-row v-else>
            <v-col class="target-score-label text-right">
              <span v-html="$t('sustainability_dashboard_ui.shore_power_utilization')"></span>
            </v-col>
            <v-col class="target-score" :class="shorePowerPercentStatusClass">
              {{ formattedMetrics.shore.shorePowerPct }}%
            </v-col>
          </v-row> -->
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import StagingRuntimeCard from '@/components/sustainability/dashboard/StagingRuntimeCard'
import InfoModal from '@/components/shared/InfoModal'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import SustainabilityMixin from '@/components/mixins/SustainabilityMixin'
import MathUtil from '@/util/MathUtil'
import DieselStagingChart from '@/components/shared/chart/DieselStagingChart'
import ShorePowerChart from '@/components/shared/chart/ShorePowerChart'
import { each, keys, get, first, clamp, cloneDeep, round } from 'lodash'

export default {
  name: 'StagingReeferActivity',
  components: {
    DieselStagingChart,
    ShorePowerChart,
    InfoModal,
    StagingRuntimeCard
  },
  mixins: [
    CurrentUserMixin,
    SustainabilityMixin
  ],
  props: {
    loading: null,
    // The raw metrics data retrieved from the API
    metricsData: null,
    stagingRuntimeMetricsData: null,
    sustainabilityCustomers: null
  },
  computed: {
    dieselUsageAboveTargetStatusClass () {
      const value = this.computedMetrics.diesel.dieselOverTargetPct
      if (value > 50) {
        return 'text-danger'
      } else if (value > 25) {
        return 'text-warning'
      } else {
        return 'text-success'
      }
    },
    shorePowerPercentStatusClass () {
      const value = this.computedMetrics.shore.shorePowerPct
      if (value < 50) {
        return 'text-danger'
      } else if (value < 75) {
        return 'text-warning'
      } else {
        return 'text-success'
      }
    },
    /**
     * Whether a single customer is selected or not
     */
    singleCustomerSelected () {
      return keys(this.metricsData).length === 1
    },
    /**
     * The selected customer, if a single customer is currently selected.
     */
    selectedCustomerId () {
      if (this.singleCustomerSelected) {
        return first(keys(this.metricsData))
      }
      return null
    },
    /**
     * Performs one additional step of formatting the metrics for display in the templates
     */
    formattedMetrics () {
      const metrics = cloneDeep(this.computedMetrics)
      const format = (x, label) => this.$n(x) + ' ' + this.$tc(label, x)

      metrics.diesel.costTotal = this.formatWholeCurrency(metrics.diesel.costTotal)
      metrics.diesel.costOverTarget = this.formatWholeCurrency(metrics.diesel.costOverTarget)
      metrics.diesel.totalDiesel = format(metrics.diesel.totalDiesel, this.dieselUnitLabelShort)
      metrics.diesel.dieselOverTarget = format(metrics.diesel.dieselOverTarget, this.dieselUnitLabelShort)
      metrics.diesel.customerTargetPerRoute = format(metrics.diesel.customerTargetPerRoute, this.dieselUnitLabelShort)
      metrics.diesel.totalCO2Emissions = format(metrics.diesel.totalCO2Emissions, this.weightFormatLabel)
      metrics.diesel.overTargetCO2Emissions = format(metrics.diesel.overTargetCO2Emissions, this.weightFormatLabel)

      metrics.shore.costSaved = this.formatWholeCurrency(metrics.shore.costSaved)
      metrics.shore.dieselSaved = format(metrics.shore.dieselSaved, this.dieselUnitLabelShort)
      metrics.shore.co2EmissionsSaved = format(metrics.shore.co2EmissionsSaved, this.weightFormatLabel)

      return metrics
    },
    stagingChartMetrics () {
      return this.sustainabilityCustomers.map(customer => ({
        ...customer,
        metricData: this.metricsData[customer.id]
      }))
    },
    /**
     * Recompute the numeric metrics according to the user's and customer's settings.
     * This both converts existing settings and computes new ones (including CO2 metrics)
     */
    computedMetrics () {
      const metrics = this.getCustomerMetrics()
      const params = this.sustainabilityParams

      const totalDiesel = this.convertDieselFromLiters(metrics.diesel.totalDiesel, 0)
      const dieselOverTarget = this.convertDieselFromLiters(metrics.diesel.dieselOverTarget, 0)
      const dieselSaved = this.convertDieselFromLiters(metrics.shore.dieselSaved, 0)
      const averageDiesel = round(totalDiesel / metrics.totalRoutes, 2)

      return {
        diesel: {
          costTotal: totalDiesel * params.dieselPrice,
          costOverTarget: dieselOverTarget * params.dieselPrice,
          costSaved: dieselSaved * params.dieselPrice,
          totalDiesel: totalDiesel,
          dieselOverTarget: dieselOverTarget,
          customerTargetPerRoute: this.convertDieselFromLiters(metrics.diesel.customerTargetPerRoute, 0),
          totalCO2Emissions: this.getCO2Emissions(metrics.diesel.totalDiesel, 0),
          overTargetCO2Emissions: this.getCO2Emissions(metrics.diesel.dieselOverTarget, 0),
          dieselOverTargetPct: round(metrics.diesel.dieselOverTargetPct, 0),
          averageDiesel: averageDiesel
        },
        shore: {
          costSaved: dieselSaved * params.dieselPrice,
          dieselSaved: dieselSaved,
          co2EmissionsSaved: this.getCO2Emissions(metrics.shore.dieselSaved, params.weightFormat, 0),
          shorePowerPct: metrics.shore.shorePowerPct,
          customerTarget: metrics.shore.customerTarget
        }
      }
    }
  },
  methods: {
    /**
     * Util function to clamp a value to 0 if lower than 0.
     * @param value
     * @returns {*}
     */
    zeroClamp (value) {
      return clamp(value, 0, value)
    },
    /**
     * Grabs the customer metrics. If multiple customers are selected, the metrics for all selected customers will be
     * tallied together.
     * @returns Object
     */
    getCustomerMetrics () {
      let results
      if (this.singleCustomerSelected) {
        const customerId = first(keys(this.metricsData))
        const data = get(this.metricsData, customerId)
        const diesel = get(data, 'diesel', {})
        const shore = get(data, 'shore', {})

        results = {
          totalRoutes: data.num_routes,
          totalStagingTime: data.total_staging_secs,
          diesel: {
            customerTargetPerRoute: diesel.power_diesel_target_l,
            customerTargetTotal: diesel.power_diesel_total_target_l,
            dieselOverTarget: diesel.power_diesel_over_target_l,
            dieselOverTargetPct: this.zeroClamp(diesel.power_diesel_vs_target_pct - 100),
            totalDiesel: diesel.power_diesel_l
          },
          shore: {
            customerTarget: shore.shore_power_target_pct,
            shorePowerTime: shore.shore_power_sec,
            shorePowerPct: shore.shore_power_pct,
            dieselSaved: shore.shore_power_diesel_saved_l
          }
        }
      } else {
        results = {
          totalRoutes: 0,
          totalStagingTime: 0,
          diesel: {
            customerTargetTotal: 0,
            dieselOverTarget: 0,
            totalDiesel: 0
          },
          shore: {
            shorePowerTime: 0,
            dieselSaved: 0
          }
        }
        each(this.metricsData, (customer) => {
          results.totalRoutes += customer.num_routes
          results.totalStagingTime += customer.total_staging_secs
          const diesel = get(customer, 'diesel', {})
          const shore = get(customer, 'shore', {})

          results.diesel.customerTargetTotal += diesel.power_diesel_total_target_l
          results.diesel.dieselOverTarget += diesel.power_diesel_over_target_l
          results.diesel.totalDiesel += diesel.power_diesel_l
          results.shore.shorePowerTime += shore.shore_power_sec
          results.shore.dieselSaved += shore.shore_power_diesel_saved_l
        })
        const dieselVsTargetPct = MathUtil.percentage(results.diesel.dieselOverTarget, results.diesel.customerTargetTotal, 1)
        results.diesel.dieselOverTargetPct = this.zeroClamp(dieselVsTargetPct - 100)
        results.shore.shorePowerPct = MathUtil.percentage(results.shore.shorePowerTime, results.totalStagingTime, 1)
      }
      return results
    }
  }
}
</script>

<style scoped lang="scss">
</style>
